module.exports = __webpack_public_path__ + "static/media/image-15.13ce0b69.jpg";